"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var __values = this && this.__values || function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator,
      m = s && o[s],
      i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function next() {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};

exports.__esModule = true;
exports.preloadReady = exports.preloadAll = exports.Capture = void 0;

var jsx_runtime_1 = require("react/jsx-runtime");

var react_1 = require("react");

var ALL_INITIALIZERS = [];
var READY_INITIALIZERS = [];
var CaptureContext = react_1.createContext(undefined);
CaptureContext.displayName = 'Capture';

function Capture(_a) {
  var report = _a.report,
      children = _a.children;
  return jsx_runtime_1.jsx(CaptureContext.Provider, __assign({
    value: report
  }, {
    children: children
  }), void 0);
}

exports.Capture = Capture;
Capture.displayName = 'Capture';

var isWebpackReady = function isWebpackReady(getModuleIds) {
  return typeof __webpack_modules__ === 'object' && getModuleIds().every(function (moduleId) {
    return typeof moduleId !== 'undefined' && typeof __webpack_modules__[moduleId] !== 'undefined';
  });
};

var load = function load(loader) {
  var state = {
    loaded: undefined,
    error: undefined
  };
  state.promise = new Promise(function (resolve, reject) {
    return __awaiter(void 0, void 0, void 0, function () {
      var _a, _b, e_1;

      return __generator(this, function (_c) {
        switch (_c.label) {
          case 0:
            _c.trys.push([0, 2,, 3]);

            _a = resolve;
            _b = state;
            return [4
            /*yield*/
            , loader()];

          case 1:
            _a.apply(void 0, [_b.loaded = _c.sent()]);

            return [3
            /*break*/
            , 3];

          case 2:
            e_1 = _c.sent();
            reject(state.error = e_1);
            return [3
            /*break*/
            , 3];

          case 3:
            return [2
            /*return*/
            ];
        }
      });
    });
  });
  return state;
};

var resolve = function resolve(obj) {
  var _a;

  return ((_a = obj) === null || _a === void 0 ? void 0 : _a.__esModule) ? obj["default"] : obj;
};

var defaultRenderer = function defaultRenderer(loaded, props) {
  var Loaded = resolve(loaded);
  return jsx_runtime_1.jsx(Loaded, __assign({}, props), void 0);
};

function createLoadableComponent(_a) {
  var _this = this;

  var Loading = _a.loading,
      loader = _a.loader,
      webpack = _a.webpack,
      _b = _a.render,
      render = _b === void 0 ? defaultRenderer : _b,
      opts = __rest(_a, ["loading", "loader", "webpack", "render"]);

  if (!Loading) throw new Error('react-loadable requires a `loading` component');
  var loadState;

  var init = function init() {
    if (!loadState) loadState = load(loader);
    return loadState.promise;
  };

  ALL_INITIALIZERS.push(init);
  if (typeof webpack === 'function') READY_INITIALIZERS.push(function () {
    if (isWebpackReady(webpack)) return init();
  });

  var LoadableComponent = function LoadableComponent(props) {
    init();
    var report = react_1.useContext(CaptureContext);

    var _a = __read(react_1.useState({
      error: loadState.error,
      loaded: loadState.loaded
    }), 2),
        state = _a[0],
        setState = _a[1];

    var mountedRef = react_1.useRef(false);
    react_1.useEffect(function () {
      mountedRef.current = true;
      return function () {
        return void (mountedRef.current = false);
      };
    }, []);
    var loadModule = react_1.useCallback(function () {
      return __awaiter(_this, void 0, void 0, function () {
        var _a, _b, moduleName, _c, newState;

        var e_2, _d;

        return __generator(this, function (_e) {
          switch (_e.label) {
            case 0:
              if (report && Array.isArray(opts['modules'])) try {
                for (_a = __values(opts['modules']), _b = _a.next(); !_b.done; _b = _a.next()) {
                  moduleName = _b.value;
                  report(moduleName);
                }
              } catch (e_2_1) {
                e_2 = {
                  error: e_2_1
                };
              } finally {
                try {
                  if (_b && !_b.done && (_d = _a["return"])) _d.call(_a);
                } finally {
                  if (e_2) throw e_2.error;
                }
              }
              if (loadState.error || loadState.loaded) return [2
              /*return*/
              ];
              _e.label = 1;

            case 1:
              _e.trys.push([1, 3, 4, 5]);

              return [4
              /*yield*/
              , loadState.promise];

            case 2:
              _e.sent();

              return [3
              /*break*/
              , 5];

            case 3:
              _c = _e.sent();
              return [3
              /*break*/
              , 5];

            case 4:
              newState = {
                error: loadState.error,
                loaded: loadState.loaded
              };
              if (mountedRef.current) setState(newState);else state = newState;
              return [7
              /*endfinally*/
              ];

            case 5:
              return [2
              /*return*/
              ];
          }
        });
      });
    }, [report, mountedRef]);
    var retry = react_1.useCallback(function () {
      return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              if (!mountedRef.current) return [2
              /*return*/
              ];
              setState({
                error: undefined,
                loaded: undefined
              });
              loadState = load(loader);
              return [4
              /*yield*/
              , loadModule()];

            case 1:
              _a.sent();

              return [2
              /*return*/
              ];
          }
        });
      });
    }, [loadModule]);
    var firstStateRef = react_1.useRef(state);

    if (firstStateRef.current) {
      loadModule();
      firstStateRef.current = undefined;
    }

    return !state.loaded || state.error ? jsx_runtime_1.jsx(Loading, {
      error: state.error,
      retry: retry
    }, void 0) : render(state.loaded, props);
  };

  LoadableComponent.preload = init;
  LoadableComponent.displayName = "LoadableComponent(" + (Array.isArray(opts['modules']) ? opts['modules'].join('-') : '') + ")";
  return LoadableComponent;
}

var flushInitializers = function flushInitializers(initializers) {
  return __awaiter(void 0, void 0, void 0, function () {
    var promises;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          promises = [];

          while (initializers.length) {
            promises.push(initializers.pop()());
          }

          return [4
          /*yield*/
          , Promise.all(promises)];

        case 1:
          _a.sent();

          if (initializers.length) return [2
          /*return*/
          , flushInitializers(initializers)];
          return [2
          /*return*/
          ];
      }
    });
  });
};

var preloadAll = function preloadAll() {
  return flushInitializers(ALL_INITIALIZERS);
};

exports.preloadAll = preloadAll;

var preloadReady = function preloadReady() {
  return flushInitializers(READY_INITIALIZERS);
};

exports.preloadReady = preloadReady;

var loadable = function loadable(opts) {
  return createLoadableComponent(opts);
};

exports["default"] = loadable;